module.exports = __webpack_public_path__ + "img/racecourse-greyville-poly-1600.e3bc8ba8.svg";